import { mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const Title = styled.h3`
  color: ${(props) => props.theme.textDark};
  margin-bottom: 20px;
  text-align: center;
  font-size: 28px;

  @media (${mobileXXLargeMax}) {
    padding: 0 20px;
  }
`;

export const TextContainer = styled.div`
  text-align: center;
  margin-top: 48px;
  margin-bottom: 15px;
`;

export default TextContainer;
